var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconoSubirArchivoAzul(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 40,
    height: 40,
    rx: 4,
    fill: "white",
    stroke: "#C7CCDC",
    strokeWidth: 0.8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.175 17.175L23.15 13.15C22.8417 12.8417 22.4167 12.6667 21.975 12.6667H16C15.0834 12.6667 14.3417 13.4167 14.3417 14.3333L14.3334 27.6667C14.3334 28.5833 15.075 29.3333 15.9917 29.3333H26C26.9167 29.3333 27.6667 28.5833 27.6667 27.6667V18.3583C27.6667 17.9167 27.4917 17.4917 27.175 17.175ZM23.3334 23.5H21.8334V26C21.8334 26.4583 21.4584 26.8333 21 26.8333C20.5417 26.8333 20.1667 26.4583 20.1667 26V23.5H18.675C18.3 23.5 18.1167 23.05 18.3834 22.7917L20.7167 20.4667C20.8834 20.3083 21.1417 20.3083 21.3084 20.4667L23.6334 22.7917C23.8834 23.05 23.7 23.5 23.3334 23.5ZM21.8334 17.6667C21.8334 18.125 22.2084 18.5 22.6667 18.5H26.4167L21.8334 13.9167V17.6667Z",
    fill: "#093C5D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoSubirArchivoAzul);
export default __webpack_public_path__ + "static/media/icono-subir-archivo-azul.6b7e33f3e3daae6bd1a842d49e7995ca.svg";
export { ForwardRef as ReactComponent };